module.exports = __webpack_public_path__ + "static/media/logo__t.ba8bddfe.svg";